import React from 'react';
import axios from 'axios';
import { Box, Typography } from '@material-ui/core';

import SearchComponent from '../../../common/elements/SearchComponent';

const LocationSearch = props => {
  const { formikProps, initialValues, label, name, onChange } = props;
  const { setFieldValue, values } = formikProps;

  const searchLocations = value => {
    return axios
      .get('/api/v2/aliases/search', {
        params: { query: value, service_id: values.service_id },
      })
      .then(({ data }) => ({ data: data.results }));
  };

  const renderLocationName = option => {
    let locationName = option;
    if (option.display_name) {
      locationName = option.display_name;
    }
    if (option.name) {
      locationName = option.name;
    }
    return locationName;
  };

  return (
    <SearchComponent
      formikProps={formikProps}
      getOptionLabel={renderLocationName}
      onBlur={() => typeof values[name] !== 'object' && setFieldValue(name, initialValues[name])}
      onChange={(_, v) => {
        setFieldValue(
          name,
          v
            ? { display_name: v.name, ...(v.location_id && { id: v.location_id }), lat: v.lat, lng: v.lng }
            : initialValues[name]
        );
        onChange(
          v ? { display_name: v.name, ...(v.location_id && { id: v.location_id }), lat: v.lat, lng: v.lng } : ''
        );
      }}
      handleSearch={searchLocations}
      label={label}
      renderOption={option => (
        <div>
          <div>{option.name}</div>
          <Box lineHeight={1}>
            <Typography color="textSecondary" variant="caption">
              {option.address}
            </Typography>
          </Box>
        </div>
      )}
      name={name}
    />
  );
};

export default LocationSearch;
